import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from 'src/app/_services';
import { RegisterUserComponent } from '../../settings/register-user/register-user.component';
import { ClinicService } from 'src/app/_services/clinic.service';
import { LazyLoadEvent, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { RegisterClinicDialogComponent } from '../register-clinic-dialog/register-clinic-dialog.component';
import { NurseAssignmentDialogComponent } from '../nurse-assignment-dialog/nurse-assignment-dialog.component';
import { Table } from 'primeng/table';
import { MenuItem } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import { CreateNurseComponent } from '../create-nurse/create-nurse.component';
import { ClinicDetailsComponent } from '../clinic-details/clinic-details.component';
import { UpdateNurseComponent } from '../update-nurse/update-nurse.component';

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss'],
})
export class AdminDashboardComponent implements OnInit {
  @ViewChild('dt') dt: Table | undefined;
  @ViewChild('cm') cm: any;
  @ViewChild('nurseCm') nurseCm: any;
  filteringFor: string = '';
  filteringForHeadOffice: string = '';
  filteringForNurse: string = '';
  filteringForHq: string = '';

  selectedRow: any;
  clinics: any[] = [];
  clinics$ = this.clinicService.clinics$;
  nurses$ = this.clinicService.nurses$;
  headOfficeUsers$ = this.clinicService.headOfficeUsers$;

  clinicAmount: number = 0;
  userAmount: number = 0;
  nurseAmount: number = 0;


  currentRole: any;

  users: any[] = [];
  hq_users: any[] = [];
  nurses: any[] = [];
  ref: any;
  loadingClinics: boolean = true;
  loadingUsers: boolean = true;
  loadingNurses: boolean = true;
  loadingPage: boolean = true;
  loadingHqUsers: boolean = true;

  menuItems: MenuItem[] = [
    {
      label: 'Update Clinic',
      icon: 'pi pi-pencil',
      command: () => {
        this.showRegisterClinicDialog(this.selectedRow);
      },
    },
    {
      label: 'Delete Clinic',
      icon: 'pi pi-trash',
      command: () => {
        this.confirmDeleteClinic();
      },
    },
    {
      label: 'Enable/Disable Clinic',
      icon: 'pi pi-power-off',
      command: () => {
        this.confirmToggleClinic();
      },
    },
  ];

  nurseMenuItems: MenuItem[] = [
    {
      label: 'Delete Nurse',
      icon: 'pi pi-trash',
      command: () => {
        this.confirmDisableNurse();
      },
    },
    {
      label: 'Edit Nurse',
      icon: 'pi pi-pencil',
      command: () => {
        this.showEditNurseDialog(this.selectedRow);
      },
    },
  ];

  metaData: any = {
    totalRecords: 0,
    limit: 100,
    offset: 0,
    loading: true,
    globalFilter: '',
    sort: '',
    id: '',
  };

  headOfficeMetaData: any = {
    totalRecords: 0,
    limit: 100,
    offset: 0,
    loading: true,
    globalFilter: '',
    sort: '',
    id: '',
  };

  hqMetaData: any = {
    totalRecords: 0,
    limit: 100,
    offset: 0,
    loading: true,
    globalFilter: '',
    sort: '',
    id: '',
  };

  nurseMetaData: any = {
    totalRecords: 0,
    limit: 100,
    offset: 0,
    loading: true,
    globalFilter: '',
    sort: '',
    id: '',
  };

  clinicColumns: any[] = [
    { field: 'name', header: 'Clinic Name' },
    { field: 'professional_nurse', header: 'Professional Nurse' },
    { field: 'contact_number', header: 'Contact Number' },
    { field: 'alternate_contact_number', header: 'Alternate Contact Number' },
    { field: 'district', header: 'District' },
    { field: 'city', header: 'City' },
    { field: 'email', header: 'Email' },
    { field: 'is_active', header: 'Status' },
    { field: 'actions', header: '' },
  ];
  userColumns: any[] = [
    { field: 'first_name', header: 'First Name' },
    { field: 'last_name', header: 'Last Name' },
    { field: 'email', header: 'Email' },
    { field: 'username', header: 'Username' },
  ];

  nurseColumns: any[] = [
    { field: 'user.first_name', header: 'First Name' },
    { field: 'user.last_name', header: 'Last Name' },
    { field: 'user.email', header: 'Email' },
    { field: 'sanc_number', header: 'SANC Number' },
    { field: 'practice_number', header: 'Practice Number' },
    { field: 'sanc_qualification', header: 'SANC Qualification' },
    { field: 'contact_number', header: 'Contact Number' },
    { field: 'alternate_contact_number', header: 'Alternate Contact Number' },
    { field: 'actions', header: '' },
  ];

  constructor(
    private userService: UserService,
    private clinicService: ClinicService,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) {}

  ngOnInit(): void {
    this.loadInitialData();

    this.userService.currentUser$.subscribe((user) => {
      this.currentRole = user?.role?.name;
    });

    this.clinicService.getNurseCount().subscribe((response: any) => {
      console.log(response);
      
      this.nurseAmount = response.body.count;
    });

    this.clinicService.getClinicCount().subscribe((response: any) => {
      this.clinicAmount = response.body.count;
    });

    this.clinicService.getHeadOfficeUserCount().subscribe((response: any) => {
      this.userAmount = response.body.count;
    });
  }

  loadInitialData(): void {
    this.loadingPage = true;
    this.loadingClinics = true;
    this.loadingUsers = true;
    this.loadingNurses = true;
    this.loadingHqUsers = true;

    // Load initial data for statistics
    this.loadClinicsLazy({ first: 0, rows: 10 });
    this.loadHeadOfficeUsersLazy({ first: 0, rows: 10 });
    this.loadNursesLazy({ first: 0, rows: 10 });
    this.loadHqUsersLazy({ first: 0, rows: 10 });
  }

  showQuickActionsMenu(): void {
    // This method can be implemented to show a quick actions menu
    // For now, it's a placeholder
    this.messageService.add({
      severity: 'info',
      summary: 'Quick Actions',
      detail: 'Quick actions menu coming soon',
      key: 'main',
    });
  }

  formatHeader(key: string): string {
    return key
      .replace(/_/g, ' ') // Replace underscores with spaces
      .replace(/\b\w/g, (c) => c.toUpperCase()); // Capitalize first letter of each word
  }

  get ClinicKeys() {
    const excludedKeys = [
      'id',
      'created_at',
      'updated_at',
      'address_line_1',
      'address_line_2',
      'suburb',
      'street_address',
      'province',
    ];
    return this.clinics.length > 0
      ? Object.keys(this.clinics[0]).filter(
          (key) => !excludedKeys.includes(key)
        )
      : [];
  }

  get UserKeys() {
    const excludedKeys = [
      'hashedpassword',
      'id',
      'role_id',
      'clinic_id',
      'created_at',
      'updated_at',
      'enabled',
    ];
    return this.users.length > 0
      ? Object.keys(this.users[0]).filter((key) => !excludedKeys.includes(key))
      : [];
  }

  getNumberOfUserColumns() {
    return this.UserKeys.length;
  }

  showUserRegisterDialog(selected_entity: any) {
    this.ref = this.dialogService.open(RegisterUserComponent, {
      data: {
        formdata: selected_entity,
      },
      header: 'Register a User',
      width: '70%',
      height: '70%',
      closeOnEscape: true,
    });

    this.ref.onClose.subscribe((res: any) => {
      if (!res) return;
      this.clinicService.getHeadOfficeUsers().subscribe((response: any) => {
        console.log(response.body);
        this.users = response.body.data;
        this.clinicService.updateHeadOfficeUsers(this.users);
        this.ClinicKeys; // Trigger change detection
      });

      this.clinicService.getAdminNurses().subscribe((response: any) => {
        console.log(response.body);
        console.log("Nurse Response: ", response);
        
        this.nurses = response.body.data;
        this.clinicService.updateNurses(this.nurses);
        this.UserKeys; // Trigger change detection
      });

      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'User Created Successfully',
        key: 'register',
      });
    });
  }

  showClinicDetails(clinic: any) {
    this.ref = this.dialogService.open(ClinicDetailsComponent, {
      data: clinic,
      header: 'Clinic Details',
      width: '70%',
      height: '70%',
      closeOnEscape: true,
    });
  }

  showCreateNurseDialog() {
    this.ref = this.dialogService.open(CreateNurseComponent, {
      header: 'Create Nurse',
      width: '70%',
      height: '70%',
      closeOnEscape: true,
    });
    this.ref.onClose.subscribe((res: any) => {
      if (!res) return;
      this.clinicService.getAdminNurses().subscribe((response: any) => {
        console.log(response.body);
        this.nurses = response.body.data;
        this.clinicService.updateNurses(this.nurses);
        this.UserKeys; // Trigger change detection
      });

      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Nurse Created Successfully',
        key: 'nurseCreation',
      });
    });
  }

  showRegisterClinicDialog(updateDetails?: any) {
    if (updateDetails) {
      this.ref = this.dialogService.open(RegisterClinicDialogComponent, {
        data: {
          formdata: updateDetails,
        },
        header: 'Update Clinic',
        width: '70%',
        height: '70%',
        closeOnEscape: true,
      });

      this.ref.onClose.subscribe((res: any) => {
        if (!res) return;
        this.clinicService.getClinics().subscribe((response: any) => {
          console.log(response.body);
          this.clinics = response.body.data;
          this.clinicService.updateClinics(this.clinics);
          this.ClinicKeys; // Trigger change detection
        });

        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Clinic Updated Successfully',
          key: 'clinicUpdate',
        });
      });
    } else {
      this.ref = this.dialogService.open(RegisterClinicDialogComponent, {
        header: 'Register a Clinic',
        width: '70%',
        height: '70%',
        closeOnEscape: true,
      });

      this.ref.onClose.subscribe((res: any) => {
        if (!res) return;
        this.clinicService.getClinics().subscribe((response: any) => {
          console.log(response.body);
          this.clinics = response.body.data;
          this.clinicService.updateClinics(this.clinics);
          this.ClinicKeys; // Trigger change detection
        });

        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Clinic Created Successfully',
          key: 'clinicCreation',
        });
      });
    }
  }

  showNurseAssignmentDialog() {
    this.ref = this.dialogService.open(NurseAssignmentDialogComponent, {
      data: {},
      header: 'Assign a Nurse',
      width: '70%',
      height: '70%',
      closeOnEscape: true,
    });

    this.ref.onClose.subscribe((res: any) => {
      if (!res) return;
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Nurse Assigned Successfully',
      });
    });
  }

  getFilterInputValue(e: Event): any {
    const inputelement = e.target as HTMLInputElement;
    this.filteringFor = 'Filtering for: ' + inputelement.value;
    if (inputelement.value === '') {
      this.filteringFor = '';
    }
    this.metaData.globalFilter = inputelement.value;
    return inputelement.value;
  }

  getFilterInputValueForHeadOffice(e: Event): any {
    const inputelement = e.target as HTMLInputElement;
    this.filteringForHeadOffice = 'Filtering for: ' + inputelement.value;
    if (inputelement.value === '') {
      this.filteringForHeadOffice = '';
    }
    this.headOfficeMetaData.globalFilter = inputelement.value;
    return inputelement.value;
  }

  getFilterInputValueForNurse(e: Event): any {
    const inputelement = e.target as HTMLInputElement;
    this.filteringForNurse = 'Filtering for: ' + inputelement.value;
    if (inputelement.value === '') {
      this.filteringForNurse = '';
    }
    this.nurseMetaData.globalFilter = inputelement.value;
    return inputelement.value;
  }

  getfilterInputValueForHq(e: Event): any {
    const inputelement = e.target as HTMLInputElement;
    this.filteringForHq = 'Filtering for: ' + inputelement.value;
    if (inputelement.value === '') {
      this.filteringForHq = '';
    }
    this.hqMetaData.globalFilter = inputelement.value;
    return inputelement.value;
  }

  loadHeadOfficeUsersLazy(event: LazyLoadEvent) {
    this.headOfficeMetaData = {
      ...this.headOfficeMetaData,
      limit: event?.rows || 500,
      offset: event?.first || 0,
      loading: true,
      globalFilter: event?.globalFilter || '',
      sort: event?.sortField || '',
    };

    this.clinicService
      .getHeadOfficeUsers(this.headOfficeMetaData)
      .subscribe((response: any) => {
        console.log(response);
        this.users = response.body.data;
        this.headOfficeMetaData.totalRecords = response.body.count;
        this.clinicService.updateHeadOfficeUsers(this.users);
        this.headOfficeMetaData.loading = false;
      });
  }

  loadHqUsersLazy(event: LazyLoadEvent) {
    this.hqMetaData = {
      ...this.hqMetaData,
      limit: event?.rows || 500,
      offset: event?.first || 0,
      loading: true,
      globalFilter: event?.globalFilter || '',
      sort: event?.sortField || '',
    };

    this.clinicService
      .getHqUsers(this.hqMetaData)
      .subscribe((response: any) => {
        console.log(response);
        this.hq_users = response.body.data;
        this.hqMetaData.totalRecords = response.body.count;
        // this.clinicService.updateHeadOfficeUsers(this.users);
        this.hqMetaData.loading = false;
      });
  }

  loadNursesLazy(event: LazyLoadEvent) {
    this.nurseMetaData = {
      ...this.nurseMetaData,
      limit: event?.rows || 500,
      offset: event?.first || 0,
      loading: true,
      globalFilter: event?.globalFilter || '',
      sort: event?.sortField || '',
    };

    this.clinicService
      .getAdminNurses(this.nurseMetaData)
      .subscribe((response: any) => {
        console.log(response);
        this.nurses = response.body.data;
        this.nurseMetaData.totalRecords = response.body.count;
        this.clinicService.updateNurses(this.nurses);
        this.nurseMetaData.loading = false;
      });
  }

  loadClinicsLazy(event: LazyLoadEvent) {
    this.metaData = {
      ...this.metaData,
      limit: event?.rows || 500,
      offset: event?.first || 0,
      loading: true,
      globalFilter: event?.globalFilter || '',
      sort: event?.sortField || '',
    };

    this.clinicService.getClinics(this.metaData).subscribe({
      next: (response: any) => {
        this.clinics = response.body.data;
        this.metaData.totalRecords = response.body.count;

        this.clinics = this.clinics.map((clinic: any) => ({
          ...clinic,
          contact_number:
            clinic.users[0]?.nurse_details?.contact_number || 'N/A',
          alternate_contact_number:
            clinic.users[0]?.nurse_details?.alternate_contact_number || 'N/A',
          email: clinic.users[0]?.email || 'N/A',
          sanc_number: clinic.users[0]?.nurse_details?.sanc_number || 'N/A',
          practice_number:
            clinic.users[0]?.nurse_details?.practice_number || 'N/A',
          sanc_qualification:
            clinic.users[0]?.nurse_details?.sanc_qualification || 'N/A',
        }));

        this.clinicService.updateClinics(this.clinics);
      },
      error: (err) => {
        console.error('Error loading clinics:', err);
        this.metaData.loading = false;
        this.clinics = [];
      },
      complete: () => {
        this.metaData.loading = false;
      },
    });
  }

  confirmToggleClinic() {
    console.log('Selected Row:', this.selectedRow);
    this.confirmationService.confirm({
      key: 'clinicToggle',
      message: this.selectedRow.is_active
        ? 'Are you sure you want to disable this clinic?'
        : 'Are you sure you want to enable this clinic?',
      accept: () => {
        if (this.selectedRow) {
          this.clinicService.toggleClinic(this.selectedRow.id).subscribe(() => {
            this.loadClinicsLazy({
              first: this.metaData.offset,
              rows: this.metaData.limit,
              globalFilter: this.metaData.globalFilter,
            });
            this.confirmationService.close();
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: this.selectedRow.is_active
                ? 'Clinic Enabled Successfully'
                : 'Clinic Disabled Successfully',
              key: 'clinicToggle',
            });
          });
        }
      },
    });
  }

  confirmDisableNurse() {
    console.log('Selected Row:', this.selectedRow);
    this.confirmationService.confirm({
      key: 'nurseToggle',
      message: 'Are you sure you want to delete this nurse?',
      accept: () => {
        if (this.selectedRow) {
          this.clinicService
            .disableNurse(this.selectedRow.user.id)
            .subscribe(() => {
              this.loadNursesLazy({
                first: this.nurseMetaData.offset,
                rows: this.nurseMetaData.limit,
                globalFilter: this.nurseMetaData.globalFilter,
              });
              this.confirmationService.close();
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: 'Nurse Disabled Successfully',
                key: 'nurseToggle',
              });
            });
        }
      },
    });
  }

  confirmDeleteClinic() {
    console.log('Selected Row:', this.selectedRow);
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this clinic?',
      accept: () => {
        if (this.selectedRow) {
          this.clinicService.deleteClinic(this.selectedRow.id).subscribe(() => {
            this.clinics = this.clinics.filter(
              (clinic) => clinic.id !== this.selectedRow.id
            );
            this.clinicService.updateClinics(this.clinics);
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Clinic Deleted Successfully',
              key: 'clinicDeletion',
            });
          });
        }
      },
    });
  }

  exportClinicsToExcel() {
    this.clinicService.exportClinicsToExcel().subscribe((response) => {
      const blob = new Blob([response.body!], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'clinic_data.xlsx';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Clinics exported successfully',
        key: 'export',
      });
    });
  }

  resolveField(data: any, field: string): any {
    return field.split('.').reduce((acc, part) => acc && acc[part], data);
  }

  showContextMenu(event: Event, clinic: any): void {
    event.preventDefault();
    event.stopPropagation();
    this.selectedRow = clinic;
    this.cm.show(event);
  }

  showEditNurseDialog(nurse: any) {
    this.ref = this.dialogService.open(UpdateNurseComponent, {
      header: 'Update Nurse',
      width: '70%',
      height: '70%',
      closeOnEscape: true,
      data: { nurse },
    });
    this.ref.onClose.subscribe((res: any) => {
      if (!res) return;
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Nurse updated successfully',
      });
      // Refresh nurses list
      this.clinicService
        .getAdminNurses(this.nurseMetaData)
        .subscribe((response: any) => {
          console.log(response.body);
          this.nurses = response.body.data;
          this.clinicService.updateNurses(this.nurses);
        });
    });
  }

  showNurseContextMenu(event: Event, nurse: any): void {
    event.preventDefault();
    event.stopPropagation();
    this.selectedRow = nurse;
    this.nurseCm.show(event);
  }

  sendPasswordResetEmail(email: string) {
    this.userService.forgotPassword(email).subscribe(() => {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        key: 'passwordReset',
        detail: 'Password reset email sent successfully',
      });
    });
  }
}
